import { Badge, Box, Grid, Text } from '@mantine/core';

import { leftArrowIcon, rightArrowIcon } from '@assets';
import { TextInput } from './';

interface Badge {
  status: 'success' | 'error';
  text: any;
}

interface InputsComparatorProps {
  title: string;
  values: [string, string];
  placeholders: [string, string];
  badge?: Badge;
  disabled?: [boolean, boolean];
  'data-pw'?: string;
}

export const InputsComparator: React.FC<InputsComparatorProps> = (props) => {
  const statusColorMapper = new Map<string, string>([
    ['success', 'green'],
    ['error', 'red'],
  ]);

  const statusColor = statusColorMapper.get(props.badge?.status ?? 'error');
  return (
    <Box>
      <Text fw="bold" mb="sm">
        {props.title}
      </Text>
      <Grid align="center">
        <Grid.Col span={5.75}>
          <TextInput
            data-pw={`${props['data-pw']}-input-1`}
            size="lg"
            label={props.placeholders[0]}
            value={props.values[0]}
            disabled={props.disabled[0]}
            badgeColor={statusColor}
            badgeMessage={props.badge?.text}
          />
        </Grid.Col>
        <Grid.Col span={0.5}>
          <img src={rightArrowIcon} />
          <img src={leftArrowIcon} />
        </Grid.Col>
        <Grid.Col span={5.75}>
          <TextInput
            data-pw={`${props['data-pw']}-input-2`}
            w="100%"
            size="lg"
            label={props.placeholders[1]}
            value={props.values[1]}
            disabled={props.disabled[1]}
          />
        </Grid.Col>
      </Grid>
    </Box>
  );
};
